
export default class mapbsRelatedrealestates {
    constructor() {
        /**@type {string} */
        this.relatedEgrid = 0;
        /**@type {number} */
        this.relatedParcelNumber = 0;
        /**@type {string} */
        this.relatedSectionNumber = '';
        /**@type {string} */
        this.relatedType = '';

    }

    getRelatedRealestate(jsonObj) {
        this.relatedEgrid = jsonObj['RelatedEgrid'];
        this.relatedParcelNumber = jsonObj['RelatedParcelNumber'];
        this.relatedSectionNumber = jsonObj['RelatedSectionNumber'];
        this.relatedType = `realestateinfo_${jsonObj['RelatedType']}`;
    }
}
